module.exports = __webpack_public_path__ + "static/media/water-supply.4c90e7d1.svg";